import React from "react";
import "./TextFlow.css";
import { adjustContentHeight } from "../../../../helpers/viewPortHelper";

export class TextFlow extends React.Component {
  
  componentDidMount() {
    this.handleScroll();
  }
  componentDidUpdate(prevProps) {
    if (this.props.data !== undefined && prevProps.data !== this.props.data) {
      this.handleScroll();
    }
  }
  handleScroll = () => {
    if (this.props.data.length > 1) this.refs[this.props.data.length - 1].scrollIntoView({ block: "end", behavior: "smooth" });
  };
  drawData = () => {
    const { data } = this.props;
    if (data.length < 1) return [];
    return data;
  };
  render() {
    const { data, questionName, showLabel = true, template, isModule, showNames } = this.props;
    let h = adjustContentHeight(window.innerHeight, template.content, template.header, template.footer);
    return (
      <div style={{ padding: "20px 0px", height: isModule ? "100%" : null }}>
       {showLabel ?
        <h1 ref={(r) => this.labelRef = r} style={{ ...template.title, padding: "15px", textAlign: "center" }}>{questionName}</h1>
       :null}
        <div className="textflow-container" style={{ height: isModule ? (showLabel && this.labelRef ? `calc(100% - ${this.labelRef.clientHeight}px)` : "100%") : h * 0.75 }}>
          {this.drawData().map((c, i) => {
            return (
              <React.Fragment key={i} >
              <div key={i} ref={i} style={{ position:"relative", backgroundColor: template.chart.textflowBgColor, color: template.chart.textflowColor, fontSize: template.text.fontSize }} className={"textflow" + (showNames?" names":"")} >
              {showNames ? <sub style={{position:"absolute", top:"calc(0.7em + 15px)", left:"15px"}}><strong>{c.name}</strong></sub> : null}
              <span dangerouslySetInnerHTML={{ __html: c.answer }}></span>
              </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    );
  }
}
